/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import ColumnDataset from '@fusioncharts/charts/src/dataset/column';
import LineDataset from './boxandwhiskerline';
import { pluck, pluckNumber, toRaphaelColor, parseConfiguration, HUNDREDSTRING, parseUnsafeString,
  parseTooltext, getDashStyle, getDefinedColor, BLANKSTRING, preDefStr, COMMASTRING, COMMA, getValidValue, POSITION_LEFT, POSITION_MIDDLE,
  visibleStr, defined, getFirstValue, datasetFactory, getSuggestiveRotation,
  convertColor, getLightColor, getColumnColor, getFirstAlpha, getFirstColor }
  from '@fusioncharts/core/src/lib';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import boxandwhisker2dAnimation from './index.animation';

let PLOTBORDERCOLOR = 'plotBorderColor',
  PLOTGRADIENTCOLOR = 'plotGradientColor',
  SHOWSHADOW = 'showShadow',
  SETROLLOVERATTR = 'setRolloverAttr',
  SETROLLOUTATTR = 'setRolloutAttr',
  UNDEFINED,
  colorStrings = preDefStr.colors,
  COLOR_000000 = colorStrings.c000000,
  strokeColor = COLOR_000000,
  LABEL = preDefStr.LABEL,
  ROLLOVER = 'DataPlotRollOver',
  ROLLOUT = 'DataPlotRollOut',
  UNDERSCORE = preDefStr.UNDERSCORE,
  POINTER = preDefStr.POINTER,
  BLANK = preDefStr.BLANK,
  ROUND = preDefStr.ROUND,
  GROUPID = preDefStr.GROUPID,
  POSITION_START = preDefStr.POSITION_START,
  POSITION_BOTTOM = preDefStr.POSITION_BOTTOM,
  POSITION_TOP = preDefStr.POSITION_TOP,
  showHoverEffectStr = preDefStr.showHoverEffectStr,
  EVENTARGS = preDefStr.EVENTARGS,
  // dataLabelStr = preDefStr.dataLabelStr,
  // shadowStr = preDefStr.shadowStr,
  POSITION_END = preDefStr.POSITION_END,
  M = 'M',
  H = 'H',
  V = 'V',
  BOLDSTARTTAG = '<b>',
  BOLDENDTAG = '</b>',
  BREAKSTRING = '<br />',
  MAXIMUM_STR = 'Maximum',
  Q3_STR = 'Q3',
  MEDIAN_STR = 'Median',
  Q1_STR = 'Q1',
  MINIMUM_STR = 'Minimum',
  pStr = preDefStr.pStr,
  sStr = preDefStr.sStr,
  NONE = 'none',
  createChildIndices = function (index, len) {
    let indices = [],
      length = len;
    while (length) {
      indices.unshift(index + Number('.' + length));
      length--;
    }
    return indices;
  },
  /**
   * Helper function to create a RedRaphael group.
   * @param  {Object} attr  Attributes applied to the created group.
   * @param  {Element} parentContainer         The parent container in which the group will be appended.
   * @param {Object} dataset The concerned dataset
   * @return {Element}                         The group that was created.
   */
  createGroup = function (attr, parentContainer, dataset) {
    return dataset.getFromEnv('animationManager').setAnimation({
      el: 'group',
      attr: attr,
      container: parentContainer,
      component: dataset,
      label: 'group'
    });
  },
  _hide = function () {
    // eslint-disable-next-line good-practices/no-function-dependency
    return function () {
      this.hide();
    };
  };
addDep({
  name: 'boxandwhisker2dAnimation',
  type: 'animationRule',
  extension: boxandwhisker2dAnimation
});
/**
 * Class for boxAndWhisker Dataset
 */
class BoxAndWhiskerDataset extends ColumnDataset {
  /**
   * function to create group for dataset
   */
  createContainer () {
    var dataset = this,
      parent = dataset.getLinkedParent(),
      group = (dataset.groupName || dataset.dsGroup || dataset.type),
      parentContainer,
      parentShadowContainer;

    !parent.getChildContainer(group + 'VcanvasGroup') && (group = 'default');
    parentContainer = parent.getChildContainer(group + 'VcanvasGroup');
    parentShadowContainer = parent.getChildContainer(group + 'ShadowVcanvasGroup'); // eslint-disable-line good-practices/no-single-usage-variable

    !dataset.getContainer('shadowGroup') && dataset.addContainer('shadowGroup',
      createGroup({ name: 'shadow-group' }, parentShadowContainer, dataset));

    !dataset.getContainer('commonElemsGroup') && dataset.addContainer('lowerBoxGroup',
      createGroup({ name: 'lower-box-group' }, parentContainer, dataset));

    !dataset.getContainer('commonElemsGroup') && dataset.addContainer('upperBoxGroup',
      createGroup({ name: 'upper-box-group' }, parentContainer, dataset));

    !dataset.getContainer('commonElemsGroup') && dataset.addContainer('upperWhiskerGroup',
      createGroup({ name: 'upper-whisker-group' }, parentContainer, dataset));

    !dataset.getContainer('commonElemsGroup') && dataset.addContainer('lowerWhiskerGroup',
      createGroup({ name: 'lower-whisker-group' }, parentContainer, dataset));

    !dataset.getContainer('commonElemsGroup') && dataset.addContainer('medianGroup',
      createGroup({ name: 'median-group' }, parentContainer, dataset));

    !dataset.getContainer('labelGroup') && dataset.addContainer('labelGroup',
      createGroup({ name: 'label-group',
        'class': 'fusioncharts-datalabels' }, parent.getChildContainer('vcanvasLabelGroup'), dataset));
  }

  /**
    * Function for parsing all the attributes and value given by the user at chart,dataset and set level.
    * @param  {Object} datasetJSON JSON for dataset configurations
    * @return {boolean} Indicates whether the configuration was successful or not
    */
  configureAttributes (datasetJSON) {
    if (!datasetJSON) {
      return false;
    }
    this.trimData(datasetJSON);
    this.config.JSONData = datasetJSON;
    var dataset = this,
      // chart = dataset.chart,
      conf = dataset.config,
      JSONData = dataset.config.JSONData,
      setDataArr = JSONData.data,
      setDataLen = setDataArr && setDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      // categories = chart.config.categories,
      // singleSeries = chart.config.singleseries,
      chartConfig = dataset.getFromEnv('chartConfig'),
      xAxis = dataset.getFromEnv('xAxis'),
      catLen = xAxis.getTicksLen(), // eslint-disable-line good-practices/no-single-usage-variable
      len = Math.min(catLen, setDataLen), // eslint-disable-line good-practices/no-single-usage-variable
      chartAttr = dataset.getFromEnv('chart-attrib'),
      colorM = dataset.getFromEnv('color-manager'),
      index = conf.index,
      plotColor = conf.plotColor = colorM.getPlotColor(index),
      plotBorderDash = pluckNumber(JSONData.dashed, chartAttr.plotborderdashed), // eslint-disable-line good-practices/no-single-usage-variable
      tooltipSepChar = parseUnsafeString(pluck(chartAttr.tooltipsepchar, ': ')),
      // parseTooltext = lib.parseTooltext,
      formatedVal,
      parserConfig,
      setTooltext,
      macroIndices,
      tempPlotfillAngle,
      toolText,
      plotDashLen,
      plotDashGap,
      plotBorderThickness,
      isRoundEdges,
      showHoverEffect,
      plotfillAngle,
      plotFillAlpha,
      // plotRadius,
      plotFillRatio,
      plotgradientcolor,
      plotBorderAlpha,
      plotBorderColor,
      // plotBorderDashStyle,
      initailPlotBorderDashStyle,
      setData,
      setValue,
      dataObj,
      config,
      label,
      // colorArr,
      upperBoxHoverColor,
      upperBoxHoverAlpha,
      upperBoxBorderHoverColor,
      upperBoxBorderHoverAlpha,
      upperBoxBorderHoverThickness,
      lowerBoxHoverColor,
      lowerBoxHoverAlpha,
      lowerBoxBorderHoverColor,
      lowerBoxBorderHoverAlpha,
      lowerBoxBorderHoverThickness,
      upperQuartileHoverColor,
      upperQuartileHoverAlpha,
      upperQuartileHoverThickness,
      lowerQuartileHoverColor,
      lowerQuartileHoverAlpha,
      lowerQuartileHoverThickness,
      medianHoverColor,
      medianHoverAlpha,
      medianHoverThickness,
      // getDashStyle = lib.getDashStyle,
      dataStore = dataset.components.data,
      numberFormatter = dataset.getFromEnv('number-formatter'),
      toolTipValue,
      setDisplayValue,
      // definedGroupPadding,

      // use3DLighting,
      parentYAxis,
      setDataDashed,
      setDataPlotDashLen,
      setDataPlotDashGap,
      i,
      maxValue = -Infinity,
      minValue = +Infinity,
      bwCalc = dataset.getFromEnv('BoxAndWhiskerStatisticalCalc'),
      quartile,
      q1,
      q3,
      limits,
      min,
      max,
      medianValue,
      mean,
      md,
      sd,
      qd,
      upperBoxColor,
      upperBoxAlpha,
      lowerBoxColor,
      lowerBoxAlpha,
      upperWhiskerAlpha,
      isMeanValueEnabledInData,
      isSDValueEnabledInData,
      isMDValueEnabledInData,
      isQDValueEnabledInData,
      isOutliersValueEnabledInData,
      difference,
      lowerWhiskerAlpha,
      upperQuartileRawColor,
      upperQuartileAlpha,
      upperBoxBorderRawColor,
      upperBoxBorderAlpha,
      lowerBoxBorderRawColor,
      lowerBoxBorderAlpha,
      lowerQuartileRawColor,
      lowerQuartileAlpha,
      isMDEnabled,
      isSDEnabled,
      isQDEnabled,
      isOutliersEnabled,
      isMeanEnabled,
      defaultValue,
      maxmin;

    dataset.setState('visible', !!(pluckNumber(dataset.config.JSONData.visible,
      !Number(dataset.config.JSONData.initiallyhidden), 1) === 1));

    parseConfiguration(JSONData, conf, chartConfig, { data: true });
    conf.defaultPadding = {
      left: 0.5,
      right: 0.5
    };
    conf.seriesname = parseUnsafeString(JSONData.seriesname);
    conf.includeInLegend = pluckNumber(JSONData.includeinlegend, (conf.seriesname ? 1 : 0));
    conf.legendSymbolColor = conf.plotColor;
    plotDashLen = conf.plotborderdashlen;
    plotDashGap = conf.plotborderdashgap;
    plotFillAlpha = conf.plotfillalpha;
    isRoundEdges = conf.useroundedges;
    plotFillRatio = conf.ratio; // eslint-disable-line good-practices/no-single-usage-variable
    plotBorderThickness = conf.plotborderthickness;

    conf.rotatevalues && (conf.rotatevalues = 270);

    conf.plotfillAngle = plotfillAngle = pluckNumber(360 - chartAttr.plotfillangle, 90);
    conf.plotColor = plotColor = pluck(JSONData.color, plotColor);
    conf.plotRadius = pluckNumber(chartAttr.useroundedges, isRoundEdges ? 1 : 0);
    conf.showTextOutline = pluckNumber(chartAttr.textoutline, 0);
    conf.plotgradientcolor = plotgradientcolor = getDefinedColor(chartAttr.plotgradientcolor, // eslint-disable-line good-practices/no-single-usage-variable
      colorM.getColor(PLOTGRADIENTCOLOR));
    !chartConfig.useplotgradientcolor && (plotgradientcolor = BLANKSTRING); // eslint-disable-line good-practices/no-single-usage-variable
    conf.plotBorderAlpha = plotBorderAlpha = conf.showplotborder ? pluck(chartAttr.plotborderalpha,
      plotFillAlpha, HUNDREDSTRING) : 0;
    conf.plotBorderColor = plotBorderColor = pluck(chartAttr.plotbordercolor,
      colorM.getColor(PLOTBORDERCOLOR));
    conf.plotBorderDashStyle = initailPlotBorderDashStyle = plotBorderDash // eslint-disable-line good-practices/no-single-usage-variable
      ? getDashStyle(plotDashLen, plotDashGap, plotBorderThickness) : NONE;

    conf.showShadow = isRoundEdges ? pluckNumber(chartAttr.showshadow, 1)
      : pluckNumber(chartAttr.showshadow, colorM.getColor(SHOWSHADOW));
    conf.showHoverEffect = showHoverEffect = pluckNumber(chartAttr.plothovereffect,
      chartAttr.showhovereffect, UNDEFINED);

    // conf.definedGroupPadding = definedGroupPadding = Math.max(pluckNumber(chartAttr.plotspacepercent), 0);
    // conf.plotSpacePercent = Math.max(pluckNumber(chartAttr.plotspacepercent, 20) % 100, 0);

    conf.parentYAxis = parentYAxis = pluck(JSONData.parentyaxis && JSONData.parentyaxis.toLowerCase(), // eslint-disable-line good-practices/no-single-usage-variable
      pStr) === sStr ? 1 : 0;

    conf.dataSeparator = COMMASTRING;

    conf.textDirection = chartAttr.hasrtltext === '1' ? 'rtl' : BLANKSTRING;

    conf.showMeanLegend = conf.showSDLegend = conf.showMDLegend = conf.showQDLegend =
      conf.showOutliersLegend = 0;

    !dataset.components.data && (dataset.components.data = []);
    dataStore = dataset.components.data;

    conf.upperBoxColor = upperBoxColor = pluck(JSONData.upperboxcolor,
      chartAttr.upperboxcolor, colorM.getPlotColor(index * 2));

    upperBoxAlpha = conf.upperBoxAlpha = pluck(JSONData.upperboxalpha,
      chartAttr.upperboxalpha, plotFillAlpha, HUNDREDSTRING);

    conf.lowerBoxColor = lowerBoxColor = pluck(JSONData.lowerboxcolor,
      chartAttr.lowerboxcolor, colorM.getPlotColor((index * 2) + 1));

    lowerBoxAlpha = conf.lowerBoxAlpha = pluck(JSONData.lowerboxalpha,
      chartAttr.lowerboxalpha, plotFillAlpha, HUNDREDSTRING);

    // Parsing the attributes and values at set level.
    for (i = 0; i < len; i++) {
      setData = setDataArr && setDataArr[i];
      dataObj = dataStore[i];
      config = dataObj && dataObj.config;

      if (!dataObj) {
        dataObj = dataStore[i] = {
          graphics: {}
        };
      }

      if (!dataObj.config) {
        config = dataStore[i].config = {};
      }

      if (setData.min && setData.max && setData.q1 && setData.q3 && setData.median) {
        quartile = {
          q1: setData.q1,
          q3: setData.q3
        };
        q1 = quartile.q1;
        q3 = quartile.q3;
        limits = {
          min: setData.min,
          max: setData.max
        };
        config.min = min = limits.min;
        config.max = max = limits.max;
        medianValue = setData.median;
        config.mean = mean = setData.mean;
        config.md = md = setData.md;
        config.sd = sd = setData.sd;
        config.qd = qd = setData.qd;
        config.outliers = setData.outliers;
        config.explicitData = true;
      } else if (setData.value) {
        config.outliers = setData.outliers;
        config.rawValue = setData.value;
        bwCalc.setArray(setData.value);
        quartile = bwCalc.getQuartiles();
        q1 = quartile.q1;
        q3 = quartile.q3;

        limits = bwCalc.getMinMax();
        config.min = min = limits.min;
        config.max = max = limits.max;
        medianValue = bwCalc.getMedian();
        config.mean = mean = bwCalc.getMean();
        config.md = md = bwCalc.getMD();
        config.sd = sd = bwCalc.getSD();
        config.qd = qd = bwCalc.getQD();
        config.explicitData = false;
        // get the valid value
        // highValue = itemValue = max;
      } else {
        config.setValue = UNDEFINED;
        config.explicitData = false;
        continue;
      }

      // if (setData.outliers) {
      //   config.outliers = setData.outliers.split(COMMA);
      //   maxNumberOfOutliers = Math.max(maxNumberOfOutliers, config.outliers.length);
      // }

      // config.showMean = showMean = pluckNumber(setData.showmean, conf.showmean);
      // config.showSD = showSD = pluckNumber(setData.showsd, conf.showsd);
      // config.showMD = showMD = pluckNumber(setData.showmd, conf.showmd);
      // config.showQD = showQD = pluckNumber(setData.showqd, conf.showqd);
      // setData.outliers && (conf.showOutliersLegend = 1);

      // showMean && (conf.showMeanLegend = 1);
      // showSD && (conf.showSDLegend = 1);
      // showMD && (conf.showMDLegend = 1);
      // showQD && (conf.showQDLegend = 1);

      upperQuartileRawColor = pluck(setData.upperquartilecolor, JSONData.upperquartilecolor,
        chartAttr.upperquartilecolor, chartAttr.plotbordercolor, colorM.getColor(PLOTBORDERCOLOR));
      upperQuartileAlpha = pluckNumber(setData.upperquartilealpha, JSONData.upperquartilealpha,
        chartAttr.upperquartilealpha, chartAttr.plotborderalpha,
        100);
      config.upperQuartile = {
        value: q3,
        color: convertColor(upperQuartileRawColor, upperQuartileAlpha),
        rawColor: upperQuartileRawColor,
        alpha: upperQuartileAlpha,
        borderWidth: pluckNumber(
          setData.upperquartilethickness, JSONData.upperquartilethickness,
          chartAttr.upperquartilethickness, chartAttr.plotborderthickness,
          !isRoundEdges ? 1 : 0),

        displayValue: numberFormatter.dataLabels(q3)
      };

      lowerQuartileRawColor = pluck(setData.lowerquartilecolor, JSONData.lowerquartilecolor,
        chartAttr.lowerquartilecolor, chartAttr.plotbordercolor, colorM.getColor(PLOTBORDERCOLOR));
      lowerQuartileAlpha = (setData.lowerquartilealpha, JSONData.lowerquartilealpha,
      chartAttr.lowerquartilealpha, chartAttr.plotborderalpha,
      100);
      config.lowerQuartile = {
        value: q1,
        color: convertColor(lowerQuartileRawColor, lowerQuartileAlpha),
        rawColor: lowerQuartileRawColor,
        alpha: lowerQuartileAlpha,
        borderWidth: pluckNumber(
          setData.lowerquartilethickness, JSONData.lowerquartilethickness,
          chartAttr.lowerquartilethickness, chartAttr.plotborderthickness,
          !isRoundEdges ? 1 : 0),

        displayValue: numberFormatter.dataLabels(q1)
      };
      config.valuePadding = pluckNumber(setData.valuepadding, conf.valuepadding);

      upperBoxBorderRawColor = pluck(setData.upperboxbordercolor, JSONData.upperboxbordercolor,
        chartAttr.upperboxbordercolor, chartAttr.plotbordercolor,
        colorM.getColor(PLOTBORDERCOLOR));
      upperBoxBorderAlpha = pluckNumber(setData.upperboxborderalpha, JSONData.upperboxborderalpha,
        chartAttr.upperboxborderalpha, chartAttr.plotborderalpha, 100);
      config.upperBoxBorder = {
        color: convertColor(upperBoxBorderRawColor, upperBoxBorderAlpha),
        rawColor: upperBoxBorderRawColor,
        alpha: upperBoxBorderAlpha,
        borderWidth: pluckNumber(
          setData.upperboxborderthickness, JSONData.upperboxborderthickness,
          chartAttr.upperboxborderthickness, !isRoundEdges && chartAttr.plotborderthickness,
          !isRoundEdges ? 1 : 0)
      };

      lowerBoxBorderRawColor = pluck(setData.lowerboxbordercolor, JSONData.lowerboxbordercolor,
        chartAttr.lowerboxbordercolor, chartAttr.plotbordercolor,
        colorM.getColor(PLOTBORDERCOLOR));
      lowerBoxBorderAlpha = pluckNumber(setData.lowerboxborderalpha, JSONData.lowerboxborderalpha,
        chartAttr.lowerboxborderalpha, chartAttr.plotborderalpha, 100);
      config.lowerBoxBorder = {
        color: convertColor(lowerBoxBorderRawColor, lowerBoxBorderAlpha),
        rawColor: lowerBoxBorderRawColor,
        alpha: lowerBoxBorderAlpha,
        borderWidth: pluckNumber(
          setData.lowerboxborderthickness, JSONData.lowerboxborderthickness,
          chartAttr.lowerboxborderthickness, !isRoundEdges && chartAttr.plotborderthickness,
          !isRoundEdges ? 1 : 0)
      };

      config.median = {
        value: medianValue,
        color: convertColor(pluck(
          setData.mediancolor, JSONData.mediancolor,
          chartAttr.mediancolor, chartAttr.plotbordercolor,
          colorM.getColor(PLOTBORDERCOLOR)),
        pluckNumber(setData.medianalpha, JSONData.medianalpha,
          chartAttr.medianalpha, chartAttr.plotborderalpha,
          100)),
        borderWidth: pluckNumber(
          setData.medianthickness, JSONData.medianthickness,
          chartAttr.medianthickness, chartAttr.plotborderthickness,
          1),

        displayValue: numberFormatter.dataLabels(medianValue)
      };
      conf.upperBoxColor = upperBoxColor = pluck(setData.upperboxcolor, JSONData.upperboxcolor,
        chartAttr.upperboxcolor, colorM.getPlotColor(index * 2));

      upperBoxAlpha = conf.upperBoxAlpha = pluck(setData.upperboxalpha, JSONData.upperboxalpha,
        chartAttr.upperboxalpha, plotFillAlpha, HUNDREDSTRING);

      conf.lowerBoxColor = lowerBoxColor = pluck(setData.lowerboxcolor, JSONData.lowerboxcolor,
        chartAttr.lowerboxcolor, colorM.getPlotColor((index * 2) + 1));

      lowerBoxAlpha = conf.lowerBoxAlpha = pluck(setData.lowerboxalpha, JSONData.lowerboxalpha,
        chartAttr.lowerboxalpha, plotFillAlpha, HUNDREDSTRING);

      config.upperBoxColor = upperBoxColor;
      config.upperBoxAlpha = upperBoxAlpha;
      config.upperColorArr = getColumnColor(
        upperBoxColor,
        upperBoxAlpha,
        UNDEFINED,
        UNDEFINED,
        isRoundEdges,
        plotBorderColor,
        plotBorderAlpha.toString(),
        0,
        false
      );

      config.lowerBoxColor = lowerBoxColor;
      config.lowerBoxAlpha = lowerBoxAlpha;
      config.lowerColorArr = getColumnColor(
        lowerBoxColor,
        lowerBoxAlpha,
        UNDEFINED,
        UNDEFINED,
        isRoundEdges,
        plotBorderColor,
        plotBorderAlpha.toString(),
        0,
        false
      );

      // Priority:
      // showValue at data level > showvalues at dataset level > showvalues at chart level

      isMeanEnabled = pluckNumber(setData.showmean, JSONData.showmean, chartAttr.showmean);
      isMeanValueEnabledInData = isMeanEnabled && pluckNumber(setData.showmeanvalue, JSONData.showmeanvalues,
        chartAttr.showmeanvalues);

      isMDEnabled = pluckNumber(setData.showmd, JSONData.showmd, chartAttr.showmd);
      isMDValueEnabledInData = isMDEnabled && pluckNumber(setData.showmdvalue, JSONData.showmdvalues,
        chartAttr.showmdvalues);

      isSDEnabled = pluckNumber(setData.showsd, JSONData.showsd, chartAttr.showsd);
      isSDValueEnabledInData = isSDEnabled && pluckNumber(setData.showsdvalue, JSONData.showsdvalues,
        chartAttr.showsdvalues);

      isQDEnabled = pluckNumber(setData.showqd, JSONData.showqd, chartAttr.showqd);
      isQDValueEnabledInData = isQDEnabled && pluckNumber(setData.showqdvalue, JSONData.showqdvalues,
        chartAttr.showqdvalues);

      isOutliersEnabled = pluckNumber(setData.showoutlier, JSONData.showoutlier, chartAttr.showoutlier);
      isOutliersValueEnabledInData = isOutliersEnabled && pluckNumber(setData.showoutliervalue, JSONData.showoutliervalues,
        chartAttr.showoutliervalues);

      defaultValue = (isMeanValueEnabledInData || isMDValueEnabledInData ||
        isSDValueEnabledInData || isQDValueEnabledInData || isOutliersValueEnabledInData) ? 0 : 1;

      config.showMinValues = pluckNumber(setData.showminvalue, setData.showvalue, JSONData.showminvalues,
        JSONData.showvalues, chartAttr.showminvalues, chartAttr.showvalues, defaultValue);

      config.showMaxValues = pluckNumber(setData.showmaxvalue, setData.showvalue, JSONData.showmaxvalues,
        JSONData.showvalues, chartAttr.showmaxvalues, chartAttr.showvalues, defaultValue);

      config.showMedianValues = pluckNumber(setData.showmedianvalue, setData.showvalue, JSONData.showmedianvalues,
        JSONData.showvalues, chartAttr.showmedianvalues, chartAttr.showvalues, defaultValue);

      config.showQ3Values = pluckNumber(setData.showq3value, JSONData.showq3values, chartAttr.showq3values, 0);

      config.showQ1Values = pluckNumber(setData.showq1value, JSONData.showq1values, chartAttr.showq1values, 0);

      config.upperWhiskerRawColor = getFirstColor(pluck(setData.upperwhiskercolor,
        JSONData.upperwhiskercolor, chartAttr.upperwhiskercolor,
        chartAttr.plotbordercolor, colorM.getColor(PLOTBORDERCOLOR)));
      config.upperWhiskerColor = convertColor(config.upperWhiskerRawColor, upperWhiskerAlpha);

      config.upperWhiskerThickness = pluckNumber(setData.upperwhiskerthickness,
        JSONData.upperwhiskerthickness, chartAttr.upperwhiskerthickness, chartAttr.plotborderthickness,
        1);

      config.upperWhiskerShadowOpacity = conf.showShadow ? (upperWhiskerAlpha / 100) : 0;

      config.lowerWhiskerAlpha = lowerWhiskerAlpha = getFirstAlpha(pluck(setData.lowerwhiskeralpha,
        JSONData.lowerwhiskeralpha, chartAttr.lowerwhiskeralpha, chartAttr.plotborderalpha, 100));

      config.lowerWhiskerRawColor = getFirstColor(pluck(setData.lowerwhiskercolor,
        JSONData.lowerwhiskercolor, chartAttr.lowerwhiskercolor, chartAttr.plotbordercolor,
        colorM.getColor(PLOTBORDERCOLOR)));
      config.lowerWhiskerColor = convertColor(config.lowerWhiskerRawColor, lowerWhiskerAlpha);

      config.lowerWhiskerThickness = pluckNumber(setData.lowerwhiskerthickness,
        JSONData.lowerwhiskerthickness, chartAttr.lowerwhiskerthickness, chartAttr.plotborderthickness,
        1);

      config.lowerWhiskerShadowOpacity = conf.showShadow ? (lowerWhiskerAlpha / 100) : 0;

      config.setValue = setValue = numberFormatter.getCleanValue(setData.value);
      config.setLink = pluck(setData.link);
      config.toolTipValue = toolTipValue = numberFormatter.dataLabels(setValue, parentYAxis);
      config.setDisplayValue = setDisplayValue = parseUnsafeString(setData.displayvalue);
      config.displayValue = pluck(setDisplayValue, toolTipValue);
      setDataDashed = pluckNumber(setData.dashed);
      setDataPlotDashLen = pluckNumber(setData.dashlen, plotDashLen);
      setDataPlotDashGap = plotDashGap = pluckNumber(setData.dashgap, plotDashGap);

      maxValue = Math.max(maxValue, max);
      minValue = Math.min(minValue, min);

      config.dataLabelStyle = dataset._configureDataLabelStyle(setData);

      // if (showAllOutliers && setData.outliers) {
      //   for (j = 0; j < config.outliers.length; j++) {
      //     maxValue = Math.max(maxValue, config.outliers[j]);
      //     minValue = Math.min(minValue, config.outliers[j]);
      //   }
      // }

      config.plotBorderDashStyle = setDataDashed === 1
        ? getDashStyle(setDataPlotDashLen, setDataPlotDashGap, plotBorderThickness)
        : (setDataDashed === 0 ? NONE : initailPlotBorderDashStyle);
      // if (singleSeries) {
      //   plotColor = colorM.getPlotColor(i);
      //   plotColor = pluck(setData.color, plotColor);
      //   plotFillRatio = pluck(setData.ratio, conf.ratio);
      // }
      // else {
      plotColor = pluck(setData.color, conf.plotColor);
      // }
      plotFillAlpha = pluck(setData.alpha, conf.plotfillalpha);

      // Setting the angle for plot fill for negative data
      if (setValue < 0 && !isRoundEdges) {
        tempPlotfillAngle = plotfillAngle;
        plotfillAngle = 360 - plotfillAngle;
      }

      // Setting the color Array to be applied to the bar/column.
      config.colorArr = getColumnColor(
        plotColor + COMMA + plotgradientcolor,
        plotFillAlpha,
        plotFillRatio,
        plotfillAngle,
        isRoundEdges,
        plotBorderColor,
        plotBorderAlpha.toString(),
        0,
        false
      );

      config.label = label =
        getValidValue(parseUnsafeString(xAxis.getLabel(pluckNumber(i)).label));

      // Parsing the hover effects only if showhovereffect is not 0.
      if (showHoverEffect !== 0) {
        upperBoxHoverColor = pluck(setData.upperboxhovercolor, JSONData.upperboxhovercolor,
          chartAttr.upperboxhovercolor, upperBoxColor);

        upperBoxHoverAlpha = pluck(setData.upperboxhoveralpha, JSONData.upperboxhoveralpha,
          chartAttr.upperboxhoveralpha, upperBoxAlpha);

        upperBoxBorderHoverColor = pluck(setData.upperboxborderhovercolor,
          JSONData.upperboxborderhovercolor,
          chartAttr.upperboxborderhovercolor, setData.upperboxbordercolor,
          JSONData.upperboxbordercolor,
          chartAttr.upperboxbordercolor, chartAttr.plotbordercolor,
          colorM.getColor(PLOTBORDERCOLOR));

        upperBoxBorderHoverAlpha = pluck(setData.upperboxborderhoveralpha,
          JSONData.upperboxborderhoveralpha,
          chartAttr.upperboxborderhoveralpha, setData.upperboxborderalpha,
          JSONData.upperboxborderalpha,
          chartAttr.upperboxborderalpha, chartAttr.plotborderalpha,
          100);

        upperBoxBorderHoverThickness = !isRoundEdges ? pluck(setData.upperboxborderhoverthickness,
          JSONData.upperboxborderhoverthickness,
          chartAttr.upperboxborderhoverthickness, config.upperBoxBorder.borderWidth) : 0;

        lowerBoxHoverColor = pluck(setData.lowerboxhovercolor, JSONData.lowerboxhovercolor,
          chartAttr.lowerboxhovercolor, lowerBoxColor);

        lowerBoxHoverAlpha = pluck(setData.lowerboxhoveralpha, JSONData.lowerboxhoveralpha,
          chartAttr.lowerboxhoveralpha, lowerBoxAlpha);

        lowerBoxBorderHoverColor = pluck(setData.lowerboxborderhovercolor,
          JSONData.lowerboxborderhovercolor,
          chartAttr.lowerboxborderhovercolor, setData.lowerboxbordercolor,
          JSONData.lowerboxbordercolor,
          chartAttr.lowerboxbordercolor, chartAttr.plotbordercolor,
          colorM.getColor(PLOTBORDERCOLOR));

        lowerBoxBorderHoverAlpha = pluck(setData.lowerboxborderhoveralpha,
          JSONData.lowerboxborderhoveralpha,
          chartAttr.lowerboxborderhoveralpha, setData.lowerboxborderalpha,
          JSONData.lowerboxborderalpha,
          chartAttr.lowerboxborderalpha, chartAttr.plotborderalpha,
          100);

        lowerBoxBorderHoverThickness = !isRoundEdges ? pluck(setData.lowerboxborderhoverthickness,
          JSONData.lowerboxborderhoverthickness,
          chartAttr.lowerboxborderhoverthickness, config.lowerBoxBorder.borderWidth) : 0;

        upperQuartileHoverColor = pluck(setData.upperquartilehovercolor,
          JSONData.upperquartilehovercolor,
          chartAttr.upperquartilehovercolor, setData.upperquartilecolor,
          JSONData.upperquartilecolor,
          chartAttr.upperquartilecolor, chartAttr.plotbordercolor,
          colorM.getColor(PLOTBORDERCOLOR));

        upperQuartileHoverAlpha = pluck(setData.upperquartilehoveralpha,
          JSONData.upperquartilehoveralpha,
          chartAttr.upperquartilehoveralpha, setData.upperquartilealpha,
          JSONData.upperquartilealpha,
          chartAttr.upperquartilealpha, chartAttr.plotborderalpha,
          100);

        upperQuartileHoverThickness = pluck(setData.upperquartilehoverthickness,
          JSONData.upperquartilehoverthickness,
          chartAttr.upperquartilehoverthickness, config.upperQuartile.borderWidth);

        lowerQuartileHoverColor = pluck(setData.lowerquartilehovercolor,
          JSONData.lowerquartilehovercolor,
          chartAttr.lowerquartilehovercolor, setData.lowerquartilecolor,
          JSONData.lowerquartilecolor,
          chartAttr.lowerquartilecolor, chartAttr.plotbordercolor,
          colorM.getColor(PLOTBORDERCOLOR));

        lowerQuartileHoverAlpha = pluck(setData.lowerquartilehoveralpha,
          JSONData.lowerquartilehoveralpha,
          chartAttr.lowerquartilehoveralpha, setData.lowerquartilealpha,
          JSONData.lowerquartilealpha,
          chartAttr.lowerquartilealpha, chartAttr.plotborderalpha,
          100);

        lowerQuartileHoverThickness = pluck(setData.lowerquartilehoverthickness,
          JSONData.lowerquartilehoverthickness,
          chartAttr.lowerquartilehoverthickness, config.lowerQuartile.borderWidth);

        medianHoverColor = pluck(setData.medianhovercolor,
          JSONData.medianhovercolor,
          chartAttr.medianhovercolor, setData.mediancolor,
          JSONData.mediancolor,
          chartAttr.mediancolor, chartAttr.plotbordercolor,
          colorM.getColor(PLOTBORDERCOLOR));

        medianHoverAlpha = pluck(setData.medianhoveralpha,
          JSONData.medianhoveralpha,
          chartAttr.medianhoveralpha, setData.medianalpha,
          JSONData.medianalpha,
          chartAttr.medianalpha, chartAttr.plotborderalpha,
          100);

        medianHoverThickness = pluck(setData.medianhoverthickness,
          JSONData.medianhoverthickness,
          chartAttr.medianhoverthickness, config.median.borderWidth);

        /* If no hover effects are explicitly defined and
         * showHoverEffect is not 0 then hoverColor is set.
         */
        if (showHoverEffect === 1) {
          upperBoxColor === upperBoxHoverColor &&
            (upperBoxHoverColor = getLightColor(upperBoxHoverColor, 70));
          lowerBoxColor === lowerBoxHoverColor &&
            (lowerBoxHoverColor = getLightColor(lowerBoxHoverColor, 70));
        }

        config.upperBoxHoverColorArr = getColumnColor(
          upperBoxHoverColor,
          upperBoxHoverAlpha,
          UNDEFINED,
          UNDEFINED,
          isRoundEdges,
          plotBorderColor,
          plotBorderAlpha.toString(),
          0,
          false
        );

        config.lowerBoxHoverColorArr = getColumnColor(
          lowerBoxHoverColor,
          lowerBoxHoverAlpha,
          UNDEFINED,
          UNDEFINED,
          isRoundEdges,
          plotBorderColor,
          plotBorderAlpha.toString(),
          0,
          false
        );

        config.setUpperBoxRolloutAttr = {
          fill: toRaphaelColor(config.upperColorArr[0])
        };
        config.setUpperBoxRolloverAttr = {
          fill: toRaphaelColor(config.upperBoxHoverColorArr[0])
        };

        config.setLowerBoxRolloutAttr = {
          fill: toRaphaelColor(config.lowerColorArr[0])
        };
        config.setLowerBoxRolloverAttr = {
          fill: toRaphaelColor(config.lowerBoxHoverColorArr[0])
        };

        config.setUpperBoxBorderRolloverAttr = {
          stroke: convertColor(upperBoxBorderHoverColor, upperBoxBorderHoverAlpha),
          'stroke-width': upperBoxBorderHoverThickness
        };
        config.setUpperBoxBorderRolloutAttr = {
          stroke: config.upperBoxBorder.color,
          'stroke-width': config.upperBoxBorder.borderWidth
        };

        config.setLowerBoxBorderRolloverAttr = {
          stroke: convertColor(lowerBoxBorderHoverColor, lowerBoxBorderHoverAlpha),
          'stroke-width': lowerBoxBorderHoverThickness
        };
        config.setLowerBoxBorderRolloutAttr = {
          stroke: config.lowerBoxBorder.color,
          'stroke-width': config.lowerBoxBorder.borderWidth
        };

        config.setUpperQuartileRolloverAttr = {
          stroke: convertColor(upperQuartileHoverColor, upperQuartileHoverAlpha),
          'stroke-width': upperQuartileHoverThickness
        };
        config.setUpperQuartileRolloutAttr = {
          stroke: config.upperQuartile.color,
          'stroke-width': config.upperQuartile.borderWidth
        };

        config.setLowerQuartileRolloverAttr = {
          stroke: convertColor(lowerQuartileHoverColor, lowerQuartileHoverAlpha),
          'stroke-width': lowerQuartileHoverThickness
        };
        config.setLowerQuartileRolloutAttr = {
          stroke: config.lowerQuartile.color,
          'stroke-width': config.lowerQuartile.borderWidth
        };

        config.setMedianRolloverAttr = {
          stroke: convertColor(medianHoverColor, medianHoverAlpha),
          'stroke-width': medianHoverThickness
        };
        config.setMedianRolloutAttr = {
          stroke: config.median.color,
          'stroke-width': config.median.borderWidth
        };
      }

      formatedVal = config.toolTipValue;

      // Parsing tooltext against various configurations provided by the user.
      setTooltext = getValidValue(parseUnsafeString(pluck(setData.tooltext,
        JSONData.plottooltext, chartAttr.plottooltext), false));
      if (!conf.showtooltip) {
        toolText = false;
      } else {
        if (formatedVal === null) {
          toolText = false;
        } else if (setTooltext !== UNDEFINED) {
          macroIndices = [1, 2, 3, 4, 5, 6, 62, 63, 64, 65,
            66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80
          ];
          parserConfig = {
            maxValue: max,
            maxDataValue: numberFormatter.dataLabels(max),
            minValue: min,
            minDataValue: numberFormatter.dataLabels(min),
            Q1: numberFormatter.dataLabels(q1),
            unformattedQ1: q1,
            Q3: numberFormatter.dataLabels(q3),
            unformattedQ3: q3,
            median: numberFormatter.dataLabels(medianValue),
            unformattedMedian: medianValue,

            SD: numberFormatter.dataLabels(sd),
            unformattedsd: sd,
            QD: numberFormatter.dataLabels(qd),
            unformattedQD: qd,
            MD: numberFormatter.dataLabels(md),
            unformattedMD: md,
            mean: numberFormatter.dataLabels(mean),
            unformattedMean: mean,
            label: label,
            yaxisName: chartConfig.yaxisname,
            xaxisName: chartConfig.xaxisname,
            formattedValue: formatedVal,
            value: label
          };
          toolText = parseTooltext(setTooltext, macroIndices,
            parserConfig, setData, chartAttr, JSONData);
        } else {
          toolText = BOLDSTARTTAG + MAXIMUM_STR + tooltipSepChar + BOLDENDTAG +
            numberFormatter.dataLabels(max) + BREAKSTRING +
            BOLDSTARTTAG + Q3_STR + tooltipSepChar + BOLDENDTAG +
            numberFormatter.dataLabels(q3) + BREAKSTRING +
            BOLDSTARTTAG + MEDIAN_STR + tooltipSepChar + BOLDENDTAG +
            numberFormatter.dataLabels(medianValue) + BREAKSTRING +
            BOLDSTARTTAG + Q1_STR + tooltipSepChar + BOLDENDTAG +
            numberFormatter.dataLabels(q1) + BREAKSTRING +
            BOLDSTARTTAG + MINIMUM_STR + tooltipSepChar + BOLDENDTAG +
            numberFormatter.dataLabels(min);
        }
      }
      config.toolText = toolText;
      config.setTooltext = toolText;
      tempPlotfillAngle && (plotfillAngle = tempPlotfillAngle);
    }

    // conf.maxNumberOfOutliers = maxNumberOfOutliers;

    if (conf.showalloutliers) {
      maxmin = dataset._getOutLiersLimit();
      maxValue = Math.max(maxValue, maxmin.max);
      minValue = Math.min(minValue, maxmin.min);
    } else {
      difference = maxValue - minValue;
      maxValue += (conf.outliersupperrangeratio * difference);
      minValue -= (conf.outlierslowerrangeratio * difference);
    }

    conf.maxValue = maxValue;
    conf.minValue = minValue;

    dataset.setState('dirty', true);
    dataset._createSubDS();
    chartConfig.showLegend && dataset._addLegend();

    // (chart.config.hasLegend !== false) && dataset._addLegend();

    // dataset.subDS = 0;

    // (dataset.components.mean = dataset._createSubDS(0, MEAN_STR));

    // conf.showMeanLegend && (dataset._addLegendSubDS(dataset.components.mean));
    // conf.showMeanLegend && (dataset.subDS += 1);

    // (dataset.components.sd = dataset._createSubDS(1, SD_STR));
    // conf.showSDLegend && (dataset._addLegendSubDS(dataset.components.sd));
    // conf.showSDLegend && (dataset.subDS += 1);

    // (dataset.components.md = dataset._createSubDS(2, MD_STR));
    // conf.showMDLegend && (dataset._addLegendSubDS(dataset.components.md));
    // conf.showMDLegend && (dataset.subDS += 1);

    // (dataset.components.qd = dataset._createSubDS(3, QD_STR));
    // conf.showQDLegend && (dataset._addLegendSubDS(dataset.components.qd));
    // conf.showQDLegend && (dataset.subDS += 1);

    // !dataset.components.outliers && (dataset.components.outliers = []);

    // OutliersLength = dataset.config.maxNumberOfOutliers || dataset.components.outliers.length;

    // for (i = 0; i < OutliersLength; i++) {
    //   outlierDS = (dataset._createSubDS(4 + i, OUTLIERS_STR, i));
    //   dataset.components.outliers[i] = outlierDS;
    // }
    // conf.showOutliersLegend && (dataset._addLegendOutliers(dataset.components.outliers));
    // conf.showOutliersLegend && (dataset.subDS += 1);
  }

  /**
   * Function to create the derived sub-dataset
   */
  _createSubDS () {
    var dataset = this,
      index = dataset.config.index,
      lineJSON = dataset.getFromEnv('lineJSON')[index],
      len = lineJSON.length;

    datasetFactory(dataset, LineDataset, 'dataset', len, lineJSON, createChildIndices(index, len));
    if (!len) {
      dataset.iterateComponents((child) => {
        if (child.getName() === 'line') {
          child.remove();
        }
      });
    }
  }

  /**
   * Function to get the maximum and minimum of the outliers
   * @return {Object} The max and min value of the outliers
   */
  _getOutLiersLimit () {
    var dataset = this,
      lineJSON = dataset.getFromEnv('lineJSON')[dataset.config.index],
      len = lineJSON.length, // eslint-disable-line good-practices/no-single-usage-variable
      dataJSON,
      dataLen,
      j,
      data,
      max = -Infinity,
      min = +Infinity,
      i;

    for (i = 0; i < len; i++) {
      dataJSON = lineJSON[i];
      if (dataJSON.seriesname === 'Outliers') {
        data = dataJSON.data;
        dataLen = data.length;
        for (j = 0; j < dataLen; j++) {
          max = Math.max(data[j].value, max);
          min = Math.min(data[j].value, min);
        }
        return {
          max: max,
          min: min
        };
      }
    }
    return {
      max,
      min
    };
  }

  /**
   * Parses plot attributes and position during post space management
   *
   * @param {any} dataObj dataObj
   * @param {any} index index
   * @memberof BoxAndWhiskerDataset
   */
  parsePlotAttributes (dataObj, index) {
    var dataset = this,
      conf = dataset.config,
      i = index,
      visible = dataset.getState('visible'),
      chartConfig = dataset.getFromEnv('chartConfig'),
      xAxis = dataset.getFromEnv('xAxis'), // eslint-disable-line good-practices/no-single-usage-variable
      yAxis = dataset.getFromEnv('yAxis'),
      xPos,
      columnWidth,
      dataStore = dataset.components.data,
      setLink,
      setValue,
      config,
      upperQuartile,
      yTop,
      yTopPos,
      lowerQuartile,
      yBottom,
      yBottomPos,
      median,
      yMed,
      yMedPos,
      upperBoxH,
      lowerBoxH,
      upperBoxBorder,
      lowerBoxBorder,
      crispX,
      crispX2,
      crispY,
      style = chartConfig.dataLabelStyle,
      hoverOutEffects,
      rotateValues = conf.rotatevalues,
      valuePadding,
      numberFormatter = dataset.getFromEnv('number-formatter'),
      textAlign = rotateValues ? POSITION_LEFT : POSITION_MIDDLE,
      smartLabel = dataset.getFromEnv('smartLabel'),
      errorStartPos,
      errorBarWidth,
      halfErrorBarW,
      errorValPos,
      crispyX,
      crispyY,
      errorPath,
      smartText,
      lineHeight,
      labelBottomY,
      labelTopY,
      lastDataSetHeight = +Infinity,
      plotDataLabelStyle,
      lastDataSetYpos,
      lowerBoxBorderEleAttr,
      lowerBoxElemAttr,
      lowerQuartileEleAttr,
      lowerWhiskerEleAttr,
      midLineElemAttr,
      upperBoxBorderEleAttr,
      upperBoxElemAttr,
      upperQuartileEleAttr,
      upperWhiskerEleAttr,
      upperQuartileMaxLabelAttr,
      upperQuartileMinLabelAttr,
      upperQuartileLabelAttr,
      lowerQuartileLabelAttr,
      medianLabelAttr,
      upperBoxStartPos,
      lowerBoxYPos,
      lowerBoxHeight,
      lowerBoxEndPos;

    columnWidth = dataset.getFromEnv('columnWidth');
    config = dataObj && dataObj.config;
    setValue = config && config.setValue;

    // If plot value is found "null", continue the loop to next iteration.
    if (!config.explicitData && (dataObj === UNDEFINED || setValue === UNDEFINED || setValue === null)) {
      return;
    }

    // isPositive = setValue >= 0;

    setLink = config.setLink;
    // Creating the data structure if not present for storing the graphics elements.
    if (!dataObj.graphics) {
      dataStore[i].graphics = {};
    }
    if (!dataObj.graphics.label) {
      dataStore[i].graphics.label = [];
    }

    // Getting the previous yposition of the plot and calculating the current yposition of the plot.
    // previousYPos = yAxis.getPixel(previousY || yBase);
    xPos = xAxis.getPixel(i) + dataset.getFromEnv('columnXShift');

    upperQuartile = config.upperQuartile || {};
    yTop = upperQuartile && upperQuartile.value;
    yTopPos = (yTop || yTop === 0) && yAxis.getPixel(yTop);

    lowerQuartile = config.lowerQuartile || {};
    yBottom = lowerQuartile && lowerQuartile.value;
    yBottomPos = (yBottom || yBottom === 0) && yAxis.getPixel(yBottom);

    median = config.median;
    yMed = median && median.value; // || yBottom;
    yMedPos = (yMed || yMed === 0) && yAxis.getPixel(yMed);

    upperBoxH = yMedPos - yTopPos;
    lowerBoxH = yBottomPos - yMedPos;

    upperBoxBorder = config.upperBoxBorder || {};
    lowerBoxBorder = config.lowerBoxBorder || {};

    valuePadding = config.valuePadding;

    config.eventArgs = {
      index: i,
      link: setLink,
      maximum: config.max,
      minimum: config.min,
      median: yMed,
      q3: upperQuartile.value,
      q1: lowerQuartile.value,
      maxDisplayValue: config.showMaxValues ? numberFormatter.dataLabels(config.max) : BLANKSTRING,
      minDisplayValue: config.showMinValues ? numberFormatter.dataLabels(config.min) : BLANKSTRING,
      medianDisplayValue: config.showMedianValues ? numberFormatter.dataLabels(yMed) : BLANKSTRING,
      q1DisplayValue: config.showQ1Values ? numberFormatter.dataLabels(lowerQuartile.value)
        : BLANKSTRING,
      q3DisplayValue: config.showQ3Values ? numberFormatter.dataLabels(upperQuartile.value)
        : BLANKSTRING,
      categoryLabel: config.label,
      toolText: config.toolText,
      datasetIndex: conf.index,
      datasetName: dataset.config.JSONData.seriesname,
      visible: visible,
      value: config.rawValue,
      showValue: config.showValue,
      upperBoxColor: config.upperBoxColor,
      upperBoxAlpha: config.upperBoxAlpha,
      lowerBoxColor: config.lowerBoxColor,
      lowerBoxAlpha: config.lowerBoxAlpha,
      upperQuartileColor: upperQuartile.rawColor,
      upperQuartileThickness: upperQuartile.borderWidth,
      upperQuartileAlpha: upperQuartile.alpha,
      lowerQuartileColor: lowerQuartile.rawColor,
      lowerQuartileThickness: lowerQuartile.borderWidth,
      lowerQuartileAlpha: lowerQuartile.alpha,
      upperBoxBorderColor: upperBoxBorder.rawColor,
      upperBoxBorderThickness: upperBoxBorder.borderWidth,
      upperBoxBorderAlpha: upperBoxBorder.alpha,
      lowerBoxBorderColor: lowerBoxBorder.rawColor,
      lowerBoxBorderThickness: lowerBoxBorder.borderWidth,
      lowerBoxBorderAlpha: lowerBoxBorder.alpha,
      upperWhiskerColor: config.upperWhiskerRawColor,
      upperWhiskerThickness: config.upperWhiskerThickness,
      lowerWhiskerThickness: config.lowerWhiskerThickness,
      lowerWhiskerColor: config.lowerWhiskerRawColor,
      upperWhiskerAlpha: config.upperWhiskerAlpha,
      lowerWhiskerAlpha: config.lowerWhiskerAlpha,
      outliers: config.outliers
    };

    // upperBox
    crispX = Math.round(xPos) + upperBoxBorder.borderWidth % 2 *
      0.5;
    crispX2 = Math.round(xPos + columnWidth) +
      upperBoxBorder.borderWidth % 2 * 0.5;
    crispY = Math.round(yTopPos) + upperQuartile.borderWidth %
      2 * 0.5;
    columnWidth = crispX2 - crispX;

    hoverOutEffects = {
      upperBox: {
        fill: toRaphaelColor(config.upperColorArr[0]), // upperQuartile.color
        'stroke-width': 0,
        'stroke-dasharray': NONE,
        cursor: setLink ? POINTER : BLANKSTRING,
        visibility: visible
      },
      lowerBox: {
        fill: toRaphaelColor(config.lowerColorArr[0]),
        'stroke-width': 0,
        'stroke-dasharray': NONE,
        cursor: setLink ? POINTER : BLANK,
        visibility: visible
      },
      upperBoxBorder: {
        stroke: upperBoxBorder.color,
        'stroke-width': upperBoxBorder.borderWidth,
        'stroke-linecap': ROUND,
        dashstyle: upperBoxBorder.dashStyle,
        visibility: visible
      },
      lowerBoxBorder: {
        stroke: lowerBoxBorder.color,
        'stroke-width': lowerBoxBorder.borderWidth,
        dashstyle: lowerBoxBorder.dashStyle,
        'stroke-linecap': ROUND,
        visibility: visible
      },
      upperQuartile: {
        stroke: toRaphaelColor(upperQuartile.color),
        'stroke-width': upperQuartile.borderWidth,
        'stroke-dasharray': upperQuartile.dashSyle,
        'stroke-linecap': ROUND,
        cursor: setLink ? POINTER : BLANK,
        visibility: visible
      },
      lowerQuartile: {
        stroke: toRaphaelColor(lowerQuartile.color),
        'stroke-width': lowerQuartile.borderWidth,
        'stroke-dasharray': lowerQuartile.dashSyle,
        cursor: setLink ? POINTER : BLANKSTRING,
        'stroke-linecap': ROUND,
        visibility: visible
      },
      median: {
        stroke: toRaphaelColor(median.color),
        'stroke-width': median.borderWidth,
        'stroke-dasharray': median.dashSyle,
        cursor: setLink ? POINTER : BLANKSTRING,
        'stroke-linecap': ROUND,
        visibility: visible
      }
    };

    upperBoxStartPos = lastDataSetYpos || crispY;

    // draw upperbox element
    upperBoxElemAttr = Object.assign({ // eslint-disable-line good-practices/no-single-usage-variable
      x: crispX,
      y: lastDataSetYpos || crispY,
      width: Math.max(columnWidth, 0),
      height: Math.max(Math.min(lastDataSetHeight, upperBoxH), 0),
      r: 0
    }, hoverOutEffects.upperBox);

    // upperBoxBorder element
    upperBoxBorderEleAttr = Object.assign({ // eslint-disable-line good-practices/no-single-usage-variable
      path: [M, crispX, lastDataSetYpos || crispY, V, lastDataSetYpos || crispY + upperBoxH,
        M, crispX2, lastDataSetYpos || crispY, V, lastDataSetYpos || crispY + upperBoxH]
    }, hoverOutEffects.upperBoxBorder);

    // upperQuartileBorder element
    upperQuartileEleAttr = Object.assign({ // eslint-disable-line good-practices/no-single-usage-variable
      path: [M, crispX, (lastDataSetYpos || crispY), H, (crispX + columnWidth)]
    }, hoverOutEffects.upperQuartile);

    errorStartPos = crispY;
    errorBarWidth = columnWidth * (conf.whiskerslimitswidthratio / 100);
    halfErrorBarW = errorBarWidth / 2;

    // Vertical Error drawing
    errorValPos = yAxis.getPixel(config.max);
    crispyY = errorValPos;
    crispyX = crispX;

    crispyY = Math.round(errorValPos) +
      (config.upperWhiskerThickness % 2 / 2);
    crispX = Math.round(crispX + (columnWidth / 2)) +
      (config.upperWhiskerThickness % 2 / 2);

    errorPath = [
      M, crispX, lastDataSetYpos || errorStartPos,
      V, Math.min(lastDataSetYpos || crispyY, upperBoxStartPos),
      M, crispX - halfErrorBarW, Math.min(lastDataSetYpos || crispyY, upperBoxStartPos),
      H, (crispX + halfErrorBarW)
    ];

    upperWhiskerEleAttr = { // eslint-disable-line good-practices/no-single-usage-variable
      path: errorPath,
      'stroke-width': config.upperWhiskerThickness,
      'cursor': setLink ? POINTER : BLANKSTRING,
      'stroke-linecap': ROUND,
      stroke: config.upperWhiskerColor,
      visibility: visible
    };

    plotDataLabelStyle = config.dataLabelStyle;
    smartLabel.useEllipsesOnOverflow(dataset.getFromEnv('chartConfig').useEllipsesWhenOverflow);
    smartLabel.setStyle(style);
    smartText = smartLabel.getOriSize(numberFormatter.dataLabels(config.max));
    lineHeight = (rotateValues ? smartText.width
      : smartText.height);
    labelTopY = errorValPos - config.upperWhiskerThickness *
      0.5 - valuePadding - lineHeight * (rotateValues ? 0.5 : 1);

    if ((labelTopY - (rotateValues ? (lineHeight / 2) : 0)) < chartConfig.canvasTop) {
      labelTopY = chartConfig.canvasTop + (rotateValues ? (lineHeight / 2) : 0);
    }

    upperQuartileMaxLabelAttr = { // eslint-disable-line good-practices/no-single-usage-variable
      text: numberFormatter.dataLabels(config.max),
      x: crispyX + columnWidth / 2,
      title: (upperQuartile.originalText || BLANKSTRING),
      y: lastDataSetYpos || labelTopY,
      'text-anchor': rotateValues ? POSITION_MIDDLE : textAlign,
      'vertical-align': rotateValues ? POSITION_MIDDLE : POSITION_TOP,
      'visibility': visibleStr,
      direction: conf.textDirection,
      fill: plotDataLabelStyle.color,
      transform: getSuggestiveRotation(rotateValues, crispyX + columnWidth / 2, labelTopY),
      'text-bound': [plotDataLabelStyle.backgroundColor, plotDataLabelStyle.borderColor,
        style.borderThickness, style.borderPadding,
        style.borderRadius, style.borderDash
      ]
    };

    crispX = Math.round(xPos) + lowerBoxBorder.borderWidth % 2 *
      0.5;
    crispX2 = Math.round(xPos + columnWidth) +
      lowerBoxBorder.borderWidth % 2 * 0.5;
    crispY = Math.round(yMedPos + lowerBoxH) +
      lowerQuartile.borderWidth % 2 * 0.5;

    lowerBoxYPos = lastDataSetYpos || yMedPos;
    lowerBoxHeight = Math.max(Math.min(lastDataSetHeight, (crispY - yMedPos)), 0);

    lowerBoxEndPos = (lowerBoxYPos + lowerBoxHeight);

    // draw lower element
    lowerBoxElemAttr = Object.assign({ // eslint-disable-line good-practices/no-single-usage-variable
      x: crispX,
      y: lowerBoxYPos,
      width: Math.max(columnWidth, 0),
      height: lowerBoxHeight,
      r: 0
    }, hoverOutEffects.lowerBox);

    // lowerBoxBorder element
    lowerBoxBorderEleAttr = Object.assign({ // eslint-disable-line good-practices/no-single-usage-variable
      path: [M, crispX, lastDataSetYpos || yMedPos, V, lastDataSetYpos || yMedPos +
        lowerBoxH, M, crispX2, lastDataSetYpos || yMedPos, V,
      lastDataSetYpos || yMedPos + lowerBoxH]
    }, hoverOutEffects.lowerBoxBorder);

    // lowerQuartileBorder element
    crispY = Math.round(yMedPos + lowerBoxH) +
      lowerQuartile.borderWidth % 2 * 0.5;

    lowerQuartileEleAttr = Object.assign({ // eslint-disable-line good-practices/no-single-usage-variable
      path: [M, crispX, lastDataSetYpos || crispY, H, (crispX + columnWidth)]
    }, hoverOutEffects.lowerQuartile);

    errorStartPos = crispY;
    errorBarWidth = columnWidth * (conf.whiskerslimitswidthratio / 100);
    halfErrorBarW = errorBarWidth / 2;

    // Vertical Error drawing
    errorValPos = yAxis.getPixel(config.min);
    crispyY = errorValPos;
    crispyX = crispX;

    crispyY = Math.round(errorValPos) +
      (config.lowerWhiskerThickness % 2 / 2);
    crispyX = Math.round(crispyX + (columnWidth / 2)) +
      (config.lowerWhiskerThickness % 2 / 2);

    errorPath = [
      M, crispyX, lastDataSetYpos || errorStartPos,
      V, Math.max(lastDataSetYpos || crispyY, lowerBoxEndPos),
      M, crispyX - halfErrorBarW, Math.max(lastDataSetYpos || crispyY, lowerBoxEndPos),
      H, (crispyX + halfErrorBarW)
    ];

    smartLabel.setStyle(style);
    smartText = smartLabel.getOriSize(numberFormatter.dataLabels(config.min));
    lineHeight = (rotateValues ? smartText.width
      : smartText.height);

    labelBottomY = errorValPos + (config.lowerWhiskerThickness * 0.5) + valuePadding;

    if ((labelBottomY + lineHeight) > chartConfig.canvasBottom) {
      labelBottomY = chartConfig.canvasBottom - lineHeight;
    }

    upperQuartileMinLabelAttr = { // eslint-disable-line good-practices/no-single-usage-variable
      text: numberFormatter.dataLabels(config.min),
      x: crispyX,
      title: (upperQuartile.originalText || BLANKSTRING),
      y: lastDataSetYpos || labelBottomY,
      'text-anchor': rotateValues ? POSITION_END : textAlign,
      'vertical-align': rotateValues ? POSITION_MIDDLE : POSITION_TOP,
      'visibility': visibleStr,
      direction: conf.textDirection,
      fill: plotDataLabelStyle.color,
      transform: getSuggestiveRotation(rotateValues, crispyX, labelBottomY),
      'text-bound': [plotDataLabelStyle.backgroundColor, plotDataLabelStyle.borderColor,
        style.borderThickness, style.borderPadding,
        style.borderRadius, style.borderDash
      ]
    };

    lowerWhiskerEleAttr = { // eslint-disable-line good-practices/no-single-usage-variable
      path: errorPath,
      'stroke-width': config.lowerWhiskerThickness,
      'cursor': setLink ? POINTER : BLANKSTRING,
      'stroke-linecap': ROUND,
      stroke: config.lowerWhiskerColor,
      visibility: visible
    };

    // medianBorder
    crispY = Math.round(yMedPos) + median.borderWidth % 2 * 0.5;

    midLineElemAttr = Object.assign({ // eslint-disable-line good-practices/no-single-usage-variable
      path: [M, crispX, lastDataSetYpos || crispY, H, (crispX + columnWidth)]
    }, hoverOutEffects.median);

    textAlign = rotateValues ? POSITION_LEFT
      : POSITION_MIDDLE;

    upperQuartileLabelAttr = { // eslint-disable-line good-practices/no-single-usage-variable
      text: upperQuartile.displayValue,
      x: xPos + (columnWidth / 2),
      title: (upperQuartile.originalText || BLANKSTRING),
      y: yTopPos - valuePadding,
      'text-anchor': rotateValues ? POSITION_START : textAlign,
      'vertical-align': rotateValues ? POSITION_MIDDLE : POSITION_BOTTOM,
      'visibility': visibleStr,
      direction: conf.textDirection,
      fill: plotDataLabelStyle.color,
      transform: getSuggestiveRotation(rotateValues, xPos + (columnWidth / 2),
        yTopPos - valuePadding),
      'text-bound': [plotDataLabelStyle.backgroundColor, plotDataLabelStyle.borderColor,
        style.borderThickness, style.borderPadding,
        style.borderRadius, style.borderDash
      ]
    };

    medianLabelAttr = { // eslint-disable-line good-practices/no-single-usage-variable
      text: median.displayValue,
      x: crispX + columnWidth / 2,
      y: yMedPos - valuePadding,
      title: (median.originalText || BLANKSTRING),
      'text-anchor': rotateValues ? POSITION_START : textAlign,
      'vertical-align': rotateValues ? POSITION_MIDDLE : POSITION_BOTTOM,
      'visibility': visibleStr,
      direction: conf.textDirection,
      fill: plotDataLabelStyle.color,
      transform: getSuggestiveRotation(rotateValues, crispX + columnWidth / 2,
        yMedPos - valuePadding),
      'text-bound': [plotDataLabelStyle.backgroundColor, plotDataLabelStyle.borderColor,
        style.borderThickness, style.borderPadding,
        style.borderRadius, style.borderDash
      ]
    };

    lowerQuartileLabelAttr = { // eslint-disable-line good-practices/no-single-usage-variable
      text: lowerQuartile.displayValue,
      x: xPos + columnWidth / 2,
      y: yBottomPos + valuePadding,
      title: (lowerQuartile.originalText || BLANKSTRING),
      'text-anchor': rotateValues ? POSITION_START : textAlign,
      'vertical-align': rotateValues ? POSITION_MIDDLE : POSITION_TOP,
      'visibility': visibleStr,
      direction: conf.textDirection,
      fill: plotDataLabelStyle.color,
      transform: getSuggestiveRotation(rotateValues, xPos + columnWidth / 2,
        yBottomPos + valuePadding),
      'text-bound': [plotDataLabelStyle.backgroundColor, plotDataLabelStyle.borderColor,
        style.borderThickness, style.borderPadding,
        style.borderRadius, style.borderDash
      ]
    };

    config.props = {
      lowerBoxBorderEle: {
        attr: lowerBoxBorderEleAttr
      },
      lowerBoxElem: {
        attr: lowerBoxElemAttr
      },
      lowerQuartileEle: {
        attr: lowerQuartileEleAttr
      },
      lowerWhiskerEle: {
        attr: lowerWhiskerEleAttr
      },
      midLineElem: {
        attr: midLineElemAttr
      },
      upperBoxElem: {
        attr: upperBoxElemAttr
      },
      upperBoxBorderEle: {
        attr: upperBoxBorderEleAttr
      },
      upperQuartileEle: {
        attr: upperQuartileEleAttr
      },
      upperWhiskerEle: {
        attr: upperWhiskerEleAttr
      },
      upperQuartileMaxLabel: {
        attr: upperQuartileMaxLabelAttr
      },
      upperQuartileMinLabel: {
        attr: upperQuartileMinLabelAttr
      },
      medianLabel: {
        attr: medianLabelAttr
      },
      upperQuartileLabel: {
        attr: upperQuartileLabelAttr
      },
      lowerQuartileLabel: {
        attr: lowerQuartileLabelAttr
      }
    };
  }
  /**
   * Parses attributes and allocates position during
   * post space management
   *
   * @memberof BoxAndWhiskerDataset
   */
  allocatePosition () {
    var dataset = this,
      setDataArr = dataset.config.JSONData.data,
      datasetLen = setDataArr && setDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      catLen = dataset.getFromEnv('xAxis').getTicksLen(), // eslint-disable-line good-practices/no-single-usage-variable
      dataStore = dataset.components.data, // eslint-disable-line good-practices/no-single-usage-variable
      dataObj,
      i,
      len;

    len = Math.min(catLen, datasetLen); // eslint-disable-line good-practices/no-single-usage-variable

    dataset.setColumnPosition();
    for (i = 0; i < len; i++) {
      dataObj = dataStore[i];
      dataset.parsePlotAttributes(dataObj, i);
    }
  }
  /**
   * functioto draw and update the graphics elements of plots
   */
  drawPlots () {
    var dataset = this,
      conf = dataset.config,
      setDataArr = dataset.config.JSONData.data,
      datasetLen = setDataArr && setDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      len,
      i,
      chart = dataset.getFromEnv('chart'),
      catLen = dataset.getFromEnv('xAxis').getTicksLen(), // eslint-disable-line good-practices/no-single-usage-variable
      toolTipController = dataset.getFromEnv('toolTipController'),
      toolText,
      dataStore = dataset.components.data,
      dataObj,
      setValue,
      config,
      showShadow = conf.showShadow,
      upperBoxContainer = dataset.getContainer('upperBoxGroup').toBack(),
      lowerBoxContainer = dataset.getContainer('lowerBoxGroup'),
      medianContainer = dataset.getContainer('medianGroup'),
      upperWhiskerContainer = dataset.getContainer('upperWhiskerGroup'),
      lowerWhiskerContainer = dataset.getContainer('lowerWhiskerGroup'),
      dataLabelContainer = dataset.getContainer('labelGroup'),
      shadowContainer = dataset.getContainer('shadowGroup'),
      upperQuartile,
      applyShadow,
      lowerQuartile,
      median,
      upperBoxElem,
      upperBoxElemCheck,
      upperBoxBorderEle,
      upperBoxBorderEleCheck,
      upperQuartileEle,
      upperQuartileEleCheck,
      lowerBoxElem,
      lowerBoxElemCheck,
      lowerBoxBorderEle,
      lowerBoxBorderEleCheck,
      lowerQuartileEle,
      lowerQuartileEleCheck,
      midLineElem,
      midLineElemCheck,
      label,
      labelCheck,
      graphic,
      groupId,
      upperWhiskerEle,
      upperWhiskerEleCheck,
      lowerWhiskerEle,
      lowerWhiskerEleCheck,
      ele,
      graphics,
      removeDataArr = dataset.components.removeDataArr || [], // eslint-disable-line good-practices/no-single-usage-variable
      removeDataArrLen = removeDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      newupperBoxElem,
      newlowerBoxElem,
      newupperBoxBorderEle,
      newlowerBoxBorderEle,
      newupperQuartileEle,
      newlowerQuartileEle,
      newmidLineElem,
      newupperWhiskerEle,
      newlowerWhiskerEle,
      hoverInAttr,
      hoverOutAttr,
      showHoverEffect = conf.showHoverEffect,
      k,
      subarr,
      arrlen,
      animationManager = dataset.getFromEnv('animationManager'),
      // Fired when clicked over the hot elements.
      clickFunc = function (ele) { // eslint-disable-line
        return function (e) {
          chart.plotEventHandler(ele, e);
        };
      },

      // Fired on mouse-in over the hot elements.
      rolloverResponseSetter = function (obj, ele) { // eslint-disable-line
        return function (data) {
          var elem;
          if (ele.data(showHoverEffectStr) !== 0) {
            for (elem in obj) {
              if (elem !== LABEL) {
                animationManager.setAnimation({
                  el: obj[elem],
                  doNotRemove: true,
                  attr: ele.data(SETROLLOVERATTR)[elem],
                  component: dataset
                });
                chart.plotEventHandler(ele, data, ROLLOVER);
              }
            }
          }
        };
      },

      // Fired on mouse-out over the hot elements.
      rolloutResponseSetter = function (obj, ele) { // eslint-disable-line
        return function (data) {
          var elem;

          if (ele.data(showHoverEffectStr) !== 0) {
            for (elem in obj) {
              if (elem !== LABEL) {
                animationManager.setAnimation({
                  el: obj[elem],
                  doNotRemove: true,
                  attr: ele.data(SETROLLOUTATTR)[elem],
                  component: dataset
                });
                chart.plotEventHandler(ele, data, ROLLOUT);
              }
            }
          }
        };
      },
      animCallBack = function () {
        if (dataset.getState('visible') === false && (dataset._conatinerHidden === false ||
            dataset._conatinerHidden === UNDEFINED)) {
          upperBoxContainer.hide();
          lowerBoxContainer.hide();
          upperWhiskerContainer.hide();
          lowerWhiskerContainer.hide();
          medianContainer.hide();
          shadowContainer.hide();
          dataLabelContainer && dataLabelContainer.hide();
          dataset._conatinerHidden = true;
        }
      };

    // eslint-disable-next-line good-practices/no-function-dependency
    applyShadow = function (shadowProps) {
      return function () {
        this.show();
        this.shadow(shadowProps);
      };
    };

    dataset.setColumnPosition();
    if (!dataset.getState('visible')) {
      dataLabelContainer.hide();
      upperWhiskerContainer.hide();
      upperBoxContainer.hide();
      lowerWhiskerContainer.hide();
      lowerBoxContainer.hide();
      medianContainer.hide();
      shadowContainer.hide();
    } else {
      // Showing the groups when visible set to true
      upperBoxContainer.show();
      lowerBoxContainer.show();
      upperWhiskerContainer.show();
      lowerWhiskerContainer.show();
      medianContainer.show();
      shadowContainer.show();
      dataLabelContainer.show();
      dataset._conatinerHidden = false;
    }

    len = Math.min(catLen, datasetLen); // eslint-disable-line good-practices/no-single-usage-variable

    // Create plot elements.
    for (i = 0; i < len; i++) {
      // setData = setDataArr && setDataArr[i];
      dataObj = dataStore[i];
      config = dataObj && dataObj.config;
      setValue = config && config.setValue;

      newupperBoxElem = false;
      newlowerBoxElem = false;
      newupperBoxBorderEle = false;
      newlowerBoxBorderEle = false;
      newupperQuartileEle = false;
      newlowerQuartileEle = false;
      newmidLineElem = false;
      newupperWhiskerEle = false;
      newlowerWhiskerEle = false;

      // If plot value is found "null", continue the loop to next iteration.
      if (!config.explicitData &&
        (dataObj === UNDEFINED || setValue === UNDEFINED || setValue === null)) {
        graphics = dataObj.graphics;
        for (ele in graphics) {
          if (graphics[ele] instanceof Array) {
            subarr = graphics[ele];
            for (k = 0, arrlen = subarr.length; k < arrlen; k++) {
              subarr[k] && subarr[k].hide();
            }
          } else {
            graphics[ele].hide();
          }
        }
        continue;
      }

      graphic = dataObj.graphics;

      // Creating the data structure if not present for storing the graphics elements.
      if (!dataObj.graphics) {
        dataStore[i].graphics = {};
      }
      if (!graphic.label) {
        dataStore[i].graphics.label = [];
      }

      upperQuartile = config.upperQuartile || {};
      lowerQuartile = config.lowerQuartile || {};

      median = config.median;
      toolText = config.toolText;
      groupId = conf.index + UNDERSCORE + i;

      upperBoxElemCheck = dataObj.graphics.upperBoxElem;
      upperBoxElem = animationManager.setAnimation({
        el: upperBoxElemCheck || 'rect',
        attr: config.props.upperBoxElem.attr,
        label: 'upperBox',
        container: upperBoxContainer,
        component: dataset
      });
      if (!upperBoxElemCheck) {
        dataObj.graphics.upperBoxElem = upperBoxElem;
        newupperBoxElem = true;
      }

      upperBoxElem.shadow({ opacity: showShadow ? conf.upperBoxAlpha / 100 : 0 }, shadowContainer);

      upperBoxBorderEleCheck = dataObj.graphics.upperBoxBorderEle;
      upperBoxBorderEle = animationManager.setAnimation({
        el: upperBoxBorderEleCheck || 'path',
        attr: config.props.upperBoxBorderEle.attr,
        container: upperBoxContainer,
        label: 'path',
        component: dataset
      });
      if (!upperBoxBorderEleCheck) {
        dataObj.graphics.upperBoxBorderEle = upperBoxBorderEle;
        newupperBoxBorderEle = true;
      }

      upperQuartileEleCheck = dataObj.graphics.upperQuartileEle;
      upperQuartileEle = animationManager.setAnimation({
        el: upperQuartileEleCheck || 'path',
        attr: config.props.upperQuartileEle.attr,
        label: 'path',
        container: upperBoxContainer,
        component: dataset
      });
      if (!upperQuartileEleCheck) {
        dataObj.graphics.upperQuartileEle = upperQuartileEle;
        newupperQuartileEle = true;
      }

      upperWhiskerEleCheck = dataObj.graphics.upperWhiskerEle;

      upperWhiskerEle = animationManager.setAnimation({
        el: upperWhiskerEleCheck || 'path',
        attr: config.props.upperWhiskerEle.attr,
        label: 'path',
        container: upperWhiskerContainer,
        component: dataset
      });
      applyShadow({ opacity: config.upperWhiskerShadowOpacity }, shadowContainer);
      if (!upperWhiskerEleCheck) {
        dataObj.graphics.upperWhiskerEle = upperWhiskerEle;
        newupperWhiskerEle = true;
      }

      dataset.getFromEnv('smartLabel').useEllipsesOnOverflow(chart.config.useEllipsesWhenOverflow);
      if (config.showMaxValues) {
        labelCheck = graphic.label[3];
        labelCheck && labelCheck.show();
        label = animationManager.setAnimation({
          el: labelCheck || 'text',
          attr: config.props.upperQuartileMaxLabel.attr,
          component: dataset,
          label: 'text',
          container: dataLabelContainer
        });
        if (!labelCheck) {
          graphic.label[3] = label;
        }
        graphic.label[3]
          .data(GROUPID, groupId);
      } else {
        graphic.label[3] && animationManager.setAnimation({
          el: graphic.label[3],
          component: dataset,
          attr: { 'text-bound': [] },
          callback: _hide.call(graphic.label[3])
        });
      }

      lowerBoxElemCheck = dataObj.graphics.lowerBoxElem;
      lowerBoxElem = animationManager.setAnimation({
        el: lowerBoxElemCheck || 'rect',
        attr: config.props.lowerBoxElem.attr,
        label: 'lowerBox',
        container: lowerBoxContainer,
        component: dataset
      });
      if (!lowerBoxElemCheck) {
        dataObj.graphics.lowerBoxElem = lowerBoxElem;
        newlowerBoxElem = true;
      }

      lowerBoxElem.shadow({ opacity: showShadow ? conf.lowerBoxAlpha / 100 : 0 }, shadowContainer);

      lowerBoxBorderEleCheck = dataObj.graphics.lowerBoxBorderEle;
      lowerBoxBorderEle = animationManager.setAnimation({
        el: lowerBoxBorderEleCheck || 'path',
        attr: config.props.lowerBoxBorderEle.attr,
        component: dataset,
        label: 'path',
        container: lowerBoxContainer
      });
      if (!lowerBoxBorderEleCheck) {
        dataObj.graphics.lowerBoxBorderEle = lowerBoxBorderEle;
        newlowerBoxBorderEle = true;
      }

      lowerQuartileEleCheck = dataObj.graphics.lowerQuartileEle;
      lowerQuartileEle = animationManager.setAnimation({
        el: lowerQuartileEleCheck || 'path',
        attr: config.props.lowerQuartileEle.attr,
        component: dataset,
        label: 'path',
        container: lowerBoxContainer
      });
      if (!lowerQuartileEleCheck) {
        dataObj.graphics.lowerQuartileEle = lowerQuartileEle;
        newlowerQuartileEle = true;
      }

      lowerWhiskerEle = dataObj.graphics.lowerWhiskerEle;

      if (config.showMinValues) {
        labelCheck = graphic.label[4];
        labelCheck && labelCheck.show();
        label = animationManager.setAnimation({
          el: labelCheck || 'text',
          attr: config.props.upperQuartileMinLabel.attr,
          label: 'text',
          container: dataLabelContainer,
          component: dataset
        });
        if (!labelCheck) {
          graphic.label[4] = label;
        }

        graphic.label[4]
          .data(GROUPID, groupId);
      } else {
        graphic.label[4] && animationManager.setAnimation({
          el: graphic.label[4],
          component: dataset,
          attr: { 'text-bound': [] },
          callback: _hide.call(graphic.label[4])
        });
      }

      lowerWhiskerEleCheck = dataObj.graphics.lowerWhiskerEle;
      lowerWhiskerEle = animationManager.setAnimation({
        el: lowerWhiskerEleCheck || 'path',
        attr: config.props.lowerWhiskerEle.attr,
        label: 'path',
        container: lowerWhiskerContainer,
        component: dataset
      });
      applyShadow({ opacity: config.lowerWhiskerShadowOpacity }, shadowContainer);
      if (!lowerWhiskerEleCheck) {
        dataObj.graphics.lowerWhiskerEle = lowerWhiskerEle;
        newlowerWhiskerEle = true;
      }

      midLineElemCheck = dataObj.graphics.midLineElem;
      midLineElem = animationManager.setAnimation({
        el: midLineElemCheck || 'path',
        component: dataset,
        label: 'midline',
        container: medianContainer,
        attr: config.props.midLineElem.attr
      });
      if (!midLineElemCheck) {
        dataObj.graphics.midLineElem = midLineElem;
        newmidLineElem = true;
      }

      hoverInAttr = {
        upperBoxElem: config.setUpperBoxRolloverAttr,
        lowerBoxElem: config.setLowerBoxRolloverAttr,
        upperBoxBorderEle: config.setUpperBoxBorderRolloverAttr,
        lowerBoxBorderEle: config.setLowerBoxBorderRolloverAttr,
        upperQuartileEle: config.setUpperQuartileRolloverAttr,
        lowerQuartileEle: config.setLowerQuartileRolloverAttr,
        midLineElem: config.setMedianRolloverAttr

      };

      hoverOutAttr = {
        upperBoxElem: config.setUpperBoxRolloutAttr,
        lowerBoxElem: config.setLowerBoxRolloutAttr,
        upperBoxBorderEle: config.setUpperBoxBorderRolloutAttr,
        lowerBoxBorderEle: config.setLowerBoxBorderRolloutAttr,
        upperQuartileEle: config.setUpperQuartileRolloutAttr,
        lowerQuartileEle: config.setLowerQuartileRolloutAttr,
        midLineElem: config.setMedianRolloutAttr
      };

      upperBoxElem.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newupperBoxElem) {
        upperBoxElem.on('fc-click', clickFunc(upperBoxElem));
        upperBoxElem.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, upperBoxElem));
        upperBoxElem.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, upperBoxElem));
      }

      lowerBoxElem.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newlowerBoxElem) {
        lowerBoxElem.on('fc-click', clickFunc(lowerBoxElem));
        lowerBoxElem.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, lowerBoxElem));
        lowerBoxElem.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, lowerBoxElem));
      }

      upperBoxBorderEle.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newupperBoxBorderEle) {
        upperBoxBorderEle.on('fc-click', clickFunc(upperBoxBorderEle));
        upperBoxBorderEle.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, upperBoxBorderEle));
        upperBoxBorderEle.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, upperBoxBorderEle));
      }

      lowerBoxBorderEle.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newlowerBoxBorderEle) {
        lowerBoxBorderEle.on('fc-click', clickFunc(lowerBoxBorderEle));
        lowerBoxBorderEle.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, lowerBoxBorderEle));
        lowerBoxBorderEle.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, lowerBoxBorderEle));
      }

      upperQuartileEle.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newupperQuartileEle) {
        upperQuartileEle.on('fc-click', clickFunc(upperQuartileEle));
        upperQuartileEle.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, upperQuartileEle));
        upperQuartileEle.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, upperQuartileEle));
      }

      lowerQuartileEle.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newlowerQuartileEle) {
        lowerQuartileEle.on('fc-click', clickFunc(lowerQuartileEle));
        lowerQuartileEle.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, lowerQuartileEle));
        lowerQuartileEle.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, lowerQuartileEle));
      }

      midLineElem.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newmidLineElem) {
        midLineElem.on('fc-click', clickFunc(midLineElem));
        midLineElem.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, midLineElem));
        midLineElem.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, midLineElem));
      }

      upperWhiskerEle.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newupperWhiskerEle) {
        upperWhiskerEle.on('fc-click', clickFunc(upperWhiskerEle));
        upperWhiskerEle.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, upperWhiskerEle));
        upperWhiskerEle.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, upperWhiskerEle));
      }

      lowerWhiskerEle.data(GROUPID, groupId)
        .data(EVENTARGS, config.eventArgs)
        .data(showHoverEffectStr, showHoverEffect)
        .data(SETROLLOVERATTR, hoverInAttr)
        .data(SETROLLOUTATTR, hoverOutAttr);

      if (newlowerWhiskerEle) {
        lowerWhiskerEle.on('fc-click', clickFunc(lowerWhiskerEle));
        lowerWhiskerEle.on('fc-mouseover', rolloverResponseSetter(dataObj.graphics, lowerWhiskerEle));
        lowerWhiskerEle.on('fc-mouseout', rolloutResponseSetter(dataObj.graphics, lowerWhiskerEle));
      }

      if (defined(upperQuartile.displayValue) &&
        upperQuartile.displayValue !== BLANK && config.showQ3Values) {
        labelCheck = graphic.label[0];
        labelCheck && labelCheck.show();
        label = animationManager.setAnimation({
          el: labelCheck || 'text',
          attr: config.props.upperQuartileLabel.attr,
          component: dataset,
          label: 'text',
          container: dataLabelContainer
        });
        if (!labelCheck) {
          graphic.label[0] = label;
        }
        graphic.label[0]
          .data(GROUPID, groupId);
      } else {
        graphic.label[0] && animationManager.setAnimation({
          el: graphic.label[0],
          component: dataset,
          attr: { 'text-bound': [] },
          callback: _hide.call(graphic.label[0])
        });
      }

      if (defined(median.displayValue) && median.displayValue !== BLANK && config.showMedianValues) {
        labelCheck = graphic.label[1];
        labelCheck && labelCheck.show();
        label = animationManager.setAnimation({
          el: labelCheck || 'text',
          attr: config.props.medianLabel.attr,
          component: dataset,
          label: 'text',
          container: dataLabelContainer
        });
        label.outlineText(conf.showTextOutline, config.props.medianLabel.attr.fill);
        if (!labelCheck) {
          graphic.label[1] = label;
        }
        graphic.label[1]
          .data(GROUPID, groupId);
      } else {
        graphic.label[1] && animationManager.setAnimation({
          el: graphic.label[1],
          component: dataset,
          attr: { 'text-bound': [] },
          callback: _hide.call(graphic.label[1])
        });
      }

      if (defined(lowerQuartile.displayValue) &&
        lowerQuartile.displayValue !== BLANK && config.showQ1Values) {
        labelCheck = graphic.label[2];
        label = animationManager.setAnimation({
          el: labelCheck || 'text',
          component: dataset,
          attr: config.props.lowerQuartileLabel.attr,
          container: dataLabelContainer
        });
        if (!labelCheck) {
          graphic.label[2] = label;
          label.show();
        }
        graphic.label[2]
          .data(GROUPID, groupId);
      } else {
        graphic.label[2] && animationManager.setAnimation({
          el: graphic.label[2],
          component: dataset,
          attr: { 'text-bound': [] },
          callback: _hide.call(graphic.label[2])
        });
      }

      if (conf.showtooltip) {
        toolTipController.enableToolTip(upperBoxElem, toolText);
        toolTipController.enableToolTip(lowerBoxElem, toolText);
        toolTipController.enableToolTip(upperBoxBorderEle, toolText);
        toolTipController.enableToolTip(lowerBoxBorderEle, toolText);
        toolTipController.enableToolTip(upperQuartileEle, toolText);
        toolTipController.enableToolTip(lowerQuartileEle, toolText);
        toolTipController.enableToolTip(midLineElem, toolText);
        toolTipController.enableToolTip(upperWhiskerEle, toolText);
        toolTipController.enableToolTip(lowerWhiskerEle, toolText);
      } else {
        toolTipController.enableToolTip(upperBoxElem, false);
        toolTipController.enableToolTip(lowerBoxElem, false);
        toolTipController.enableToolTip(upperBoxBorderEle, false);
        toolTipController.enableToolTip(lowerBoxBorderEle, false);
        toolTipController.enableToolTip(upperQuartileEle, false);
        toolTipController.enableToolTip(lowerQuartileEle, false);
        toolTipController.enableToolTip(midLineElem, false);
        toolTipController.enableToolTip(upperWhiskerEle, false);
        toolTipController.enableToolTip(lowerWhiskerEle, false);
      }
    }

    // There has to be a provision such that the callback is called after the end of the slot animation
    animCallBack();
    removeDataArrLen && dataset.removePlots();
  }
  /**
   * Function to remove a data from a dataset
   */
  removePlots () {
    var dataSet = this,
      removeDataArr = dataSet.components.removeDataArr,
      animationManager = dataSet.getFromEnv('animationManager'), // eslint-disable-line good-practices/no-single-usage-variable
      len = removeDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      removeData,
      ele,
      graphics,
      i,
      innerLen,
      j;

    for (i = 0; i < len; i++) {
      removeData = removeDataArr[0];
      removeDataArr.splice(0, 1);
      // In case of non existing data plot continue;
      if (!removeData || !removeData.graphics) {
        continue;
      }

      graphics = removeData.graphics;
      for (ele in graphics) {
        if (ele !== LABEL) {
          graphics[ele].shadow({ opacity: 0 });
          graphics[ele].hide();
        } else {
          innerLen = graphics[ele].length;
          for (j = 0; j < innerLen; j++) {
            if (graphics[ele][j]) {
              graphics[ele][j].shadow({ opacity: 0 });
              animationManager.setAnimation({
                el: graphics[ele][j],
                component: dataSet,
                attr: { 'text-bound': [] },
                callback: _hide.call(graphics[ele][j])
              });
            }
          }
        }
      }
    }
  }

  /**
   * Function to remove a data with a given index.
   * @param {number}  indexVal     from which index data would be removed
   * @param {number}  stretchVal   delete count
   * @param {boolean} draw      whether draw or not
   */
  removeData (indexVal, stretchVal, draw) {
    var dataSet = this,
      index = indexVal,
      stretch = stretchVal,
      components = dataSet.components,
      dataStore = components.data,
      removeDataArr = components.removeDataArr || (components.removeDataArr = []); // eslint-disable-line good-practices/no-single-usage-variable

    stretch = stretch || 1;
    index = index || 0;

    // Storing the direction of input data for the type of animation to be done during remove.
    if ((index + stretch) === dataStore.length) {
      dataSet.endPosition = true;
    } else if (index === 0 || index === UNDEFINED) {
      dataSet.endPosition = false;
    }

    components.removeDataArr = removeDataArr = removeDataArr.concat(dataStore.splice(index, stretch)); // eslint-disable-line good-practices/no-single-usage-variable

    draw && dataSet.asyncDraw();
  }
  /**
   * parse defualt configuration of the dataset
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.showplotborder = UNDEFINED;
    config.plotborderdashlen = UNDEFINED;
    config.plotborderdashgap = UNDEFINED;
    config.plotfillalpha = UNDEFINED;
    config.useroundedges = UNDEFINED;
    config.ratio = UNDEFINED;
    config.plotborderthickness = UNDEFINED;
    config.showvalues = UNDEFINED;
    config.valuepadding = UNDEFINED;
    config.showtooltip = UNDEFINED;
    config.maxcolwidth = UNDEFINED;
    config.rotatevalues = UNDEFINED;
    config.use3dlighting = UNDEFINED;
    config.whiskerslimitswidthratio = UNDEFINED;
    config.outliersupperrangeratio = UNDEFINED;
    config.outlierslowerrangeratio = UNDEFINED;
    config.showalloutliers = UNDEFINED;
    config.showmean = UNDEFINED;
    config.showsd = UNDEFINED;
    config.showmd = UNDEFINED;
    config.showqd = UNDEFINED;
    config.showminvalues = UNDEFINED;
    config.showmaxvalues = UNDEFINED;
    config.showq1values = UNDEFINED;
    config.showq3values = UNDEFINED;
    config.showmedianvalues = UNDEFINED;
  }

  /**
   * Function to get the maximum and minimum from dataset
   * @return {Object}     contains max, min value
   */
  getDataLimits () {
    var dataset = this,
      conf = dataset.config,
      removed = dataset.getState('removed');
    return {
      max: removed ? -Infinity : conf.maxValue,
      min: removed ? +Infinity : conf.minValue
    };
  }

  /**
   * Function to register datasets in the internal data store of legend class.
   */
  _addLegend () {
    var dataset = this,
      // chart = dataset.chart,
      fillColor,
      config,
      conf = dataset.config,
      legendItem,
      legend = dataset.getFromEnv('legend'),
      chartAttr = dataset.getFromEnv('chart-attrib'),
      JSONData = conf.JSONData || {},
      upperBoxColor = conf.upperBoxColor,
      lowerBoxColor = conf.lowerBoxColor; // eslint-disable-line good-practices/no-single-usage-variable

    fillColor = { // eslint-disable-line good-practices/no-single-usage-variable
      FCcolor: {
        color: upperBoxColor + COMMA + lowerBoxColor,
        angle: 90,
        ratio: '50, 0',
        alpha: '100, 100'
      }
    };

    config = { // eslint-disable-line good-practices/no-single-usage-variable
      label: getFirstValue(dataset.config.JSONData.seriesname),
      index: dataset.getJSONIndex(),
      mainDS: true
    };
    if (conf.includeInLegend) {
      legendItem = legend.getItem(dataset.config.legendItemId);
      if (!legendItem) {
        dataset.config.legendItemId = legend.createItem(dataset);
        legendItem = legend.getItem(dataset.config.legendItemId);
        dataset.addExtEventListener('fc-click', function () {
          legendItem.itemClickFn();
        }, legendItem);
      }
      legendItem.configure(config);

      legendItem.setStateCosmetics('default', {
        symbol: {
          fill: toRaphaelColor(fillColor),
          bgAlpha: pluckNumber(JSONData.legendiconbgalpha, JSONData.legendiconalpha, chartAttr.legendiconbgalpha, chartAttr.legendiconalpha, conf.plotfillalpha),
          borderAlpha: pluckNumber(JSONData.legendiconborderalpha, JSONData.legendiconalpha, chartAttr.legendiconborderalpha, chartAttr.legendiconalpha, conf.plotfillalpha),
          rawFillColor: conf.upperBoxColor,
          stroke: toRaphaelColor(strokeColor)
        },
        background: {
          legendBackgroundColor: toRaphaelColor(upperBoxColor),
          alpha: 20
        }
      });
      // check if dataset is initiallyhidden
      if (!dataset.getState('visible')) {
        legendItem.setLegendState('hidden');
      } else { // remove hidden state of legend item if dataset is not hidden
        legendItem.removeLegendState('hidden');
      }
    } else if (dataset.config.legendItemId) {
      legend.disposeItem(dataset.config.legendItemId);
    }
    dataset._mapChildren((child) => {
      if (!child.getState('removed')) {
        child.addToEnv('legendBackgroundColor', upperBoxColor);
        child && child._addLegend(true);
      }
    });
  }

  /**
   * Fuction to be fired on legend click
   * @param  {Object} legendItem which legend is clicked
   */
  legendInteractivity () {
    var dataset = this,
      childDS = dataset.getChildren('dataset'),
      state,
      i;
    state = dataset.getState('visible') ? 'hide' : 'show';

    for (i = 0; i < (childDS && childDS.length); i++) {
      childDS[i][state]();
    }
    dataset[state]();
  }

  /**
   * Over-writting drawLabel of column chart
   * @return {Object} the dataset object
   */
  drawLabel () {
    return this;
  }
  /**
   * Gets the name of the component
   * @return {string} name
   */
  getName () {
    return 'boxandwhisker2D';
  }

  /**
   * Over-writting childChanged of column chart
   * @return {Object} the dataset object
   */
  childChanged () {
    return this;
  }

  /**
   * Function to show the dataset and raise an event
   */
  show () {
    super.show();
  }

  /**
   * Function to hide the dataset and raise an event
   */
  hide () {
    super.hide();
  }
}

export default BoxAndWhiskerDataset;
